<h2 mat-dialog-title class="mat-dialog-title--icons flex items-center justify-start gap-2">
  <mat-icon svgIcon="google-classroom"></mat-icon>
  <span i18n>Share to Google Classroom</span>
</h2>
@if (!courses.length) {
  <mat-dialog-content>
    <div class="info-block">
      <p i18n>Hey there! Looks like you don't have any active Google Classroom classes.</p>
      <p i18n>
        Visit <a href="https://classroom.google.com" target="_blank">Google Classroom</a> to create
        a class and try again.
      </p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="closeAll()" i18n>OK</button>
  </mat-dialog-actions>
}
@if (courses.length && !isAdded) {
  <form [formGroup]="form" (ngSubmit)="addToClassroom()">
    <mat-dialog-content class="dialog-content-scroll flex flex-col">
      <p class="mat-body-1 accent-1">
        {{ data.run.name }} <span class="mat-caption" i18n>(Run ID: {{ data.run.id }})</span>
      </p>
      <p i18n>Add an assignment for this unit to Google Classroom.</p>
      <h3 i18n>1. Choose from your Google Classroom classes</h3>
      <div formArrayName="selectedCourses">
        @for (control of selectedCoursesControl.controls; track control; let i = $index) {
          <p>
            <mat-checkbox [formControl]="control">
              {{ courses[i].name }}
              @if (courses[i].section) {
                <ng-container i18n> (Section {{ courses[i].section }})</ng-container>
              }
            </mat-checkbox>
          </p>
        }
      </div>
      <mat-divider />
      <h3 i18n>2. Add Description</h3>
      <mat-form-field appearance="fill">
        <mat-label i18n>Assignment description</mat-label>
        <textarea matInput formControlName="description"></textarea>
        <mat-error i18n>Description is required.</mat-error>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="closeAll()" [disabled]="isAdding" i18n>Cancel</button>
      <button
        mat-flat-button
        type="submit"
        color="primary"
        [disabled]="form.invalid || isAdding"
        class="button--progress"
      >
        @if (isAdding) {
          <mat-progress-bar mode="indeterminate" />
        }
        <ng-container i18n>Add</ng-container>
      </button>
    </mat-dialog-actions>
  </form>
}
@if (isAdded && courses.length) {
  <mat-dialog-content>
    <div class="info-block">
      <p class="mat-body-1 accent-1">
        {{ data.run.name }} <span class="mat-caption" i18n>(Run ID: {{ data.run.id }})</span>
      </p>
      @if (addSuccessCount > 0) {
        <div>
          <br />
          <p i18n>
            The unit has been successfully added to the following Google Classroom classes:
          </p>
          @for (course of coursesSuccessfullyAdded; track course) {
            <p>{{ course.name }}</p>
          }
        </div>
      }
      @if (addFailureCount > 0) {
        <div style="color: red">
          <br />
          <p i18n>There was a problem adding the unit to the following Google Classroom classes:</p>
          @for (course of coursesFailedToAdd; track course) {
            <p>{{ course.name }}</p>
          }
        </div>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="closeAll()" i18n>Done</button>
  </mat-dialog-actions>
}
